import { DataTypeEnum } from "../_common/enum/dataType.enum";
import { IDropdownData } from "../_common/interface/dropdown/iDropdownData.interface";
import { dropdownService } from "../_services/dropdown.service";

export function normalizeDropdownItem(item: Record<string, unknown>): IDropdownData {
    return {
        id: (item.id ?? item.Id) as number,
        name: String(item.name ?? item.Name ?? ""),
        group: String(item.group ?? item.Group ?? item.ticketType ?? item.TicketType ?? ""),
    };
}

export function normalizeDropdownItems(json: unknown): IDropdownData[] {
    if (!Array.isArray(json)) return [];
    return json.map((item) => normalizeDropdownItem(item as Record<string, unknown>));
}

export function sortDropdownItemsByGroup(items: IDropdownData[]): IDropdownData[] {
    return [...items].sort((a, b) => {
        const groupCompare = (a.group ?? "").localeCompare(b.group ?? "");
        if (groupCompare !== 0) return groupCompare;
        return (a.name ?? "").localeCompare(b.name ?? "");
    });
}

/** Loads all ticket action lists with ticket type labels for grouped filter dropdowns. */
export async function loadGroupedTicketActionLists(): Promise<IDropdownData[]> {
    const types = await dropdownService.fetchFormDataMultiple(DataTypeEnum.TicketType);
    const typeItems = normalizeDropdownItems(types);

    const grouped = await Promise.all(
        typeItems.map(async (type) => {
            const lists = await dropdownService.fetchFormDataMultiple(
                DataTypeEnum.TicketActionLists,
                type.id
            );

            return normalizeDropdownItems(lists).map((list) => ({
                ...list,
                group: type.name,
            }));
        })
    );

    return sortDropdownItemsByGroup(grouped.flat());
}
